<div class="flex flex-col gap-4">
  <soft-ds-kpi
    [title]="('#WORKHOURS.TITLE' | translate) ?? ''"
    [value]="dayWorkDecimal()"
    [prevValue]="dayTargetHours()"
    [formatFn]="formatHms"
    [badgeFormatFn]="formatHourDelta"
    variant="bar"
    color="gradient"
    [animateValue]="false"
    [progressScale]="100 / 150"
    [comparisonLabel]="('#WORKHOURS.TARGET' | translate) ?? ''"
    [progressLabel]="('#WORKHOURS.OF_TARGET' | translate) ?? ''"
  />

  <soft-ds-kpi
    [title]="('#WORKHOURS.WEEK' | translate) ?? ''"
    [value]="weekWorkDecimal()"
    [prevValue]="weekTargetHours()"
    [formatFn]="formatHms"
    [badgeFormatFn]="formatHourDelta"
    variant="bar"
    color="gradient"
    [animateValue]="false"
    [progressScale]="100 / 150"
    [comparisonLabel]="('#WORKHOURS.TARGET' | translate) ?? ''"
    [progressLabel]="('#WORKHOURS.OF_TARGET' | translate) ?? ''"
  />

  <soft-ds-kpi
    [title]="('#WORKHOURS.PAUSE' | translate) ?? ''"
    [value]="pauseDecimal()"
    [formatFn]="formatHm"
    variant="number"
    [showBadge]="false"
    [animateValue]="false"
  />
</div>
